import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ButtonSocialShareFacebookComponent extends Vue {
    @Prop({
        default: () => document.location!.href.replace(document.location!.hash, '')
    })
    pageUrl: string;

    @Prop()
    lable: string;

    @Prop({
        default: true
    })
    hasIcon: boolean;

    @Prop({
        default: true
    })
    hasCounter: boolean;

    counter: string = '0';

    mounted() {
        if (this.hasCounter) {
            this.fetchShareCounter();
        }
    }

    getRandomInt(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    sliceThousandInt(number: number): string {
        return (number / 1000).toFixed(1) + 'k';
    }

    showShareWindow(): void {
        const shareUrl = `https://www.facebook.com/sharer/sharer.php` +
            `?u=${encodeURIComponent(this.pageUrl)}`;
        const width = 640;
        const height = 640;
        const left = screen.width / 2 - width / 2;
        const top = screen.height / 2 - height / 2;
        const windowConfig = `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=no`;

        window.open(shareUrl, 'Share this', windowConfig);
    }

    fetchShareCounter(): void {
        const script = document.createElement('script');
        const callback = 'share_' + this.getRandomInt(1, 2345);

        script.src = `https://graph.facebook.com?id=${encodeURIComponent(this.pageUrl)}&callback=${callback}`;
        document.body.appendChild(script);
        window[callback] = (count) => {
            if (count.share) {
                this.counter = count.share.share_count >= 1000
                    ? this.sliceThousandInt(count.share.share_count)
                    : count.share.share_count;
            }
        };
    }
}
